import { render, staticRenderFns } from "./archived.vue?vue&type=template&id=da901f44&"
import script from "./archived.vue?vue&type=script&lang=js&"
export * from "./archived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports